export function createDefaultBannerStyle () {
  return {
    positionX: 'right',
    positionY: 'bottom',
    axisY: false,
    marginX: '15',
    marginY: '15',
    size: '60'
  }
}

export function createDefaultBannerActiveStyle () {
  return {
    active: false,
    positionX: 'right',
    positionY: 'bottom',
    axisY: false,
    marginX: '15',
    marginY: '15',
    size: '60'
  }
}